import React, { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router';

import { StringParam, useQueryParam } from 'use-query-params';

import { PERMISSION_TYPE, useRBAC } from 'hooks/useRBAC';
import { useCreateReport } from 'queries/reports';

import { DOWNLOAD_KEYS } from './constants';
import { REPORTS } from './helpers';
import Downloads from './index';

export const useDownloads = (downloadKey?: DOWNLOAD_KEYS) => {
  const location = useLocation();

  const { checkPermission } = useRBAC();

  const [queryTab] = useQueryParam('tab', StringParam);

  const pathname = Object.keys(REPORTS).filter((path) =>
    matchPath(path, location.pathname),
  )[0];

  const pageReportInfo = REPORTS[pathname];

  const reportsList = useMemo(() => {
    const reportsList = pageReportInfo?.filter((item) => {
      return (
        (item.tab === undefined || (queryTab !== undefined && item.tab === queryTab)) &&
        checkPermission({
          conditionType: item.permissionsType || PERMISSION_TYPE.OR,
          list: item.permissions,
        })
      );
    });

    const filteredReports =
      reportsList?.length === 1
        ? reportsList
        : reportsList?.filter(
            (item) => item.key !== undefined && item.key === downloadKey,
          );

    return {
      createPath: filteredReports?.length === 1 ? filteredReports?.[0].path : undefined,
      reports: reportsList,
    };
  }, [pageReportInfo, queryTab, checkPermission, downloadKey]);

  const { mutate: createReport } = useCreateReport(reportsList.createPath);

  const downloadsButton = !!reportsList.reports?.length && (
    <Downloads reports={reportsList.reports} />
  );

  return {
    canCreateReport: !!reportsList.createPath,
    createReport,
    downloadsButton,
  };
};
